import { render } from "./TariffEndsHeader.vue?vue&type=template&id=1b5e27f0"
import script from "./TariffEndsHeader.vue?vue&type=script&lang=js"
export * from "./TariffEndsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__